import React, { useRef, useLayoutEffect, useEffect, useState } from 'react';
import { JqueryClassFaker } from '../components/JqueryClassFaker';

let instanceCount = 0;
export default React.forwardRef(
	function TextInput({
		                   label,
		                   type = 'text',
		                   error,
		                   success,
		                   className,
		                   id,
		                   textarea,
		                   timePicker,
		                   timeChanged,
		                   ...props
	                   }, ref) {

		const instanceNumber = useRef(instanceCount++);
		const timePickerRef = useRef(null);
		const [hasInputRef, updateHasInputRef] = useState(0);
		const refHelper = useRef(null);


		const getInputRef = (newRef) => {
			if(ref) {
				ref.current = newRef;
			}
			refHelper.current = newRef;
			updateHasInputRef(newRef);
		};

		useEffect(() => {
			if(refHelper.current) {
				if(timePicker) {
					timePickerRef.current = M.Timepicker.init(refHelper.current, {
						container: '#page_dashboard',
						onSelect: onTimeSelect,
						format: 'hh:i A',
						twelveHour: true,
						onCloseStart: onTimeCloseStart
					});
					console.log(timePickerRef.current);
				}

			}
			if(textarea && refHelper.current) {
				M.textareaAutoResize(refHelper.current);
			}
			else {
				M.updateTextFields();
			}
		}, [hasInputRef]);

		function onTimeSelect(hour, minutes, third) {
			timeChanged(hour, minutes, timePickerRef.current.amOrPm);
		}

		function onTimeCloseStart() {
			timeChanged(timePickerRef.current.hours, timePickerRef.current.minutes, timePickerRef.current.amOrPm);
		}

		const idToUse = id || `text_input_${instanceNumber.current}`;

		const classes = new JqueryClassFaker(className);
		if(error) {
			classes.add('validate invalid');
		}
		if(success) {
			classes.add('validate valid');
		}
		if(textarea) {
			classes.add('materialize-textarea');
		}

		const inputProps = {
			...props,
			id: idToUse,
			className: classes.toString(),
			ref: getInputRef
		};
		return (
			<React.Fragment>
				{!textarea &&
				<input
					type={type}
					{...inputProps}
				/>
				}
				{textarea &&
				<textarea {...inputProps} />
				}
				<label htmlFor={idToUse}>{label}</label>
				{error &&
				<span className='helper-text' data-error={error} data-success={success} />
				}
			</React.Fragment>
		);

	});

